"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigKeysList = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const ProjectConfigStoreDataProvider_1 = require("src/configeek_assets/src/components/common/provider/ProjectConfigStoreDataProvider");
const antd_1 = require("antd");
const use_custom_compare_1 = require("use-custom-compare");
const lodash_1 = __importDefault(require("lodash"));
const icons_1 = require("@ant-design/icons");
const RemoveProjectConfigKeyModalComponent_1 = require("src/configeek_assets/src/components/loggedIn/common/RemoveProjectConfigKeyModalComponent");
const isMounted_1 = __importDefault(require("src/configeek_assets/src/system/hooks/isMounted"));
const CurrentProjectProvider_1 = require("src/configeek_assets/src/components/common/provider/CurrentProjectProvider");
const PutProjectConfigKeyModalComponent_1 = require("src/configeek_assets/src/components/loggedIn/common/PutProjectConfigKeyModalComponent");
const ValueOrEmptyStringComponent_1 = require("src/configeek_assets/src/components/loggedIn/common/ValueOrEmptyStringComponent");
const appICUtils_1 = require("src/configeek_assets/src/ic/appICUtils");
const ShowNewLinesSettingsComponent_1 = require("src/configeek_assets/src/components/common/widget/ShowNewLinesSettingsComponent");
const AutoWrapContainer_1 = require("src/configeek_assets/src/components/loggedIn/common/AutoWrapContainer");
const ExportCSVButton_1 = require("src/configeek_assets/src/components/loggedIn/common/ExportCSVButton");
const ConfigKeysList = () => {
    var _a;
    const isMounted = (0, isMounted_1.default)();
    const currentProjectContext = (0, CurrentProjectProvider_1.useCurrentProjectContext)();
    const projectConfigStoreDataContext = (0, ProjectConfigStoreDataProvider_1.useProjectConfigStoreDataContext)();
    const canEditKeys = appICUtils_1.ParticipantUtils.hasProjectParameterEditAccess(currentProjectContext.projectData.view.participant);
    const { inProgress } = projectConfigStoreDataContext.config.status;
    const [pagination] = (0, react_1.useState)({ hideOnSinglePage: false, defaultPageSize: 25, showSizeChanger: true, pageSizeOptions: [10, 25, 50, 100], showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items` });
    const [newLinesVisible, setNewLinesVisible] = (0, react_1.useState)(false);
    const [configKeyValuePairInModal, setConfigKeyValuePairInModal] = (0, react_1.useState)();
    const [canEditInModal, setCanEditInModal] = (0, react_1.useState)(false);
    //edit configKey
    const [editConfigKeyModalVisible, setEditConfigKeyModalVisible] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), { visible: false, nonce: 0 });
    const onEditConfigKeyModalDestroy = (0, react_1.useCallback)(() => {
        if (isMounted()) {
            setEditConfigKeyModalVisible({ visible: false });
        }
    }, [isMounted]);
    //remove configKey
    const [removeConfigKeyModalVisibility, setRemoveConfigKeyModalVisibility] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), { visible: false, nonce: 0 });
    const onRemoveConfigKeyModalDestroy = (0, react_1.useCallback)(() => {
        if (isMounted()) {
            setRemoveConfigKeyModalVisibility({ visible: false });
        }
    }, [isMounted]);
    const onClickMenuEdit = (0, react_1.useCallback)((record) => {
        setConfigKeyValuePairInModal({
            key: record.key,
            value: record.value
        });
        setCanEditInModal(true);
        setEditConfigKeyModalVisible({ visible: true, nonce: editConfigKeyModalVisible.nonce + 1 });
    }, [editConfigKeyModalVisible.nonce]);
    const onClickMenuView = (0, react_1.useCallback)((record) => {
        setConfigKeyValuePairInModal({
            key: record.key,
            value: record.value
        });
        setCanEditInModal(false);
        setEditConfigKeyModalVisible({ visible: true, nonce: editConfigKeyModalVisible.nonce + 1 });
    }, [editConfigKeyModalVisible.nonce]);
    const onClickMenuRemove = (0, react_1.useCallback)((record) => {
        // console.log("onClickMenuRemove", record);
        setConfigKeyValuePairInModal({
            key: record.key,
            value: record.value
        });
        setRemoveConfigKeyModalVisibility({ visible: true, nonce: removeConfigKeyModalVisibility.nonce + 1 });
    }, [removeConfigKeyModalVisibility.nonce]);
    const tableColumns = (0, use_custom_compare_1.useCustomCompareMemo)(() => {
        const keyWidth = canEditKeys ? "40%" : "40%";
        const valueWidth = canEditKeys ? "59%" : "59%";
        const actionsWidth = canEditKeys ? "1%" : "1%";
        return lodash_1.default.compact([
            {
                title: "Key",
                render: (value, record) => {
                    return React.createElement(AutoWrapContainer_1.AutoWrapContainer, null,
                        React.createElement("span", { className: "asLinkOnHover displayInlineBlock", onClick: () => canEditKeys ? onClickMenuEdit(record) : onClickMenuView(record) }, record.key));
                },
                sorter: (a, b) => a.key.localeCompare(b.key),
                width: keyWidth,
            },
            {
                title: "Value",
                render: (value, record) => React.createElement(AutoWrapContainer_1.AutoWrapContainer, null,
                    React.createElement(ValueOrEmptyStringComponent_1.ValueOrEmptyStringComponent, { value: record.value, showViewLines: newLinesVisible })),
                sorter: (a, b) => a.value.localeCompare(b.value),
                width: valueWidth,
            }, {
                render: (value, record) => {
                    const canBeEdited = canEditKeys;
                    const canBeRemoved = canEditKeys;
                    const items = [];
                    if (canBeEdited) {
                        items.push({
                            key: "edit",
                            label: "Edit",
                            onClick: () => onClickMenuEdit(record)
                        });
                    }
                    else {
                        items.push({
                            key: "view",
                            label: "View",
                            onClick: () => onClickMenuView(record)
                        });
                    }
                    if (canBeRemoved) {
                        items.push({
                            key: "remove",
                            label: "Remove",
                            danger: true,
                            onClick: () => onClickMenuRemove(record)
                        });
                    }
                    const menu = React.createElement(antd_1.Menu, { items: items });
                    return React.createElement(antd_1.Dropdown, { overlay: menu, trigger: ["click"], placement: "bottomRight" },
                        React.createElement(antd_1.Button, { type: "link", icon: React.createElement(icons_1.MoreOutlined, { style: { fontSize: "20px" } }) }));
                },
                width: actionsWidth
            }
        ]);
    }, [onClickMenuEdit, onClickMenuRemove, canEditKeys, newLinesVisible], lodash_1.default.isEqual);
    const dataSource = (0, use_custom_compare_1.useCustomCompareMemo)(() => {
        var _a;
        return lodash_1.default.sortBy(lodash_1.default.map((_a = projectConfigStoreDataContext.config.data) === null || _a === void 0 ? void 0 : _a.configKeys, configKeyValuePair => {
            return {
                key: configKeyValuePair.key,
                value: configKeyValuePair.value
            };
        }), v => v.key);
    }, [(_a = projectConfigStoreDataContext.config.data) === null || _a === void 0 ? void 0 : _a.configKeys], lodash_1.default.isEqual);
    const newLinesVisibleSettings = React.createElement(ShowNewLinesSettingsComponent_1.ShowNewLinesSettingsComponent, { value: newLinesVisible, onChange: setNewLinesVisible, disabled: inProgress, bottomPadding: false });
    const settings = React.createElement(antd_1.Space, { direction: "horizontal", size: "large", style: { width: "100%", justifyContent: "flex-end", paddingBottom: 10 } },
        newLinesVisibleSettings,
        React.createElement(ExportCSVButton_1.ExportCSVButton, { size: "small", dataSource: dataSource, identifier: `configuration_${currentProjectContext.projectData.view.project.projectName}`, disabled: inProgress }));
    return React.createElement(React.Fragment, null,
        settings,
        React.createElement(PutProjectConfigKeyModalComponent_1.PutProjectConfigKeyModalComponent, { key: `editConfKey${editConfigKeyModalVisible.nonce}${configKeyValuePairInModal === null || configKeyValuePairInModal === void 0 ? void 0 : configKeyValuePairInModal.key}`, visible: editConfigKeyModalVisible.visible, onDestroy: onEditConfigKeyModalDestroy, projectApiKey: currentProjectContext.projectData.view.project.projectApiKey, configKeyValuePair: configKeyValuePairInModal, canEdit: canEditInModal }),
        React.createElement(RemoveProjectConfigKeyModalComponent_1.RemoveProjectConfigKeyModalComponent, { key: `${removeConfigKeyModalVisibility.nonce}${configKeyValuePairInModal === null || configKeyValuePairInModal === void 0 ? void 0 : configKeyValuePairInModal.key}`, visible: removeConfigKeyModalVisibility.visible, onDestroy: onRemoveConfigKeyModalDestroy, projectName: currentProjectContext.projectData.view.project.projectName, configKeyValuePair: configKeyValuePairInModal }),
        React.createElement(antd_1.Table, { dataSource: dataSource, columns: tableColumns, loading: inProgress, pagination: pagination, showSorterTooltip: false }));
};
exports.ConfigKeysList = ConfigKeysList;
